import * as React from "react"

function SvgNotificationsOff(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.202.05-.397.122-.585.191l-.105.039L18 13.1V11zm-6 11c1.1 0 2-.9 2-2h-4a2 2 0 002 2zM6.81 7.57L4 4.76l1.41-1.41 15.98 15.98-1.41 1.41L18.24 19H4v-1l2-2v-5c0-1.27.29-2.43.81-3.43z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgNotificationsOff

